import { CostEnum } from "packages/libs/shared-models/src/Enum/cost-enum";

export class RootWiseCostReq{
    routeType: CostEnum;
    cost:number;
    createdUser : string;
    id?: number;

    constructor(routeType: CostEnum,cost:number,createdUser : string,id?: number){
        this.routeType = routeType
        this.cost=cost
        this.createdUser = createdUser
        this.id = id
    }
}